export default "__VITE_ASSET__7KM1N4mA__"